import { User } from "../../types"

export type CurrentUserState = User | null

export enum CurrentUserActionTypes {
  UPDATE = '@@current_user/UPDATE',
}

export interface UpdateAction {
  type: CurrentUserActionTypes.UPDATE;
  payload: CurrentUserState;
}
